import { defineComposable } from '@/core/utils/defineComposable'
import type VueIntercom from '@/services/vue-intercom/types'
import type { Ref } from 'vue'
import { ref } from 'vue'
import { getCurrentInstance } from 'vue'

export const useIntercom = defineComposable(() => {
  const vm = getCurrentInstance()
  if (!vm) {
    throw new Error(
      'getCurrentInstance() returned null. Method must be called at the top of a setup function',
    )
  }

  const injected = vm.appContext.config.globalProperties.$intercom

  const intercom = injected ? injected.intercom : null

  const visible = injected ? injected.visible : ref(false)

  return { intercom, visible } as {
    intercom: VueIntercom | null
    visible: Ref<boolean>
  }
})

export const INTERCOM_EVENT = {
  UPGRADE: 'upgrade_request',
  SUPPORT: 'support_request',
} as const
